<template>
    <transition name="fade">
        <div v-if="isVisible" id="tip_popup" @click="closePopup">
            <div class="tip_popup" @click.stop>
                <div class="tip_popup1">{{ title }}</div>
                <div class="tip_popup2">
                   <div class="contont">
                        <div
                            v-for="(block, bIndex) in blocks"
                            :key="bIndex"
                            :class="['reduce-block', block.type]"
                        >
                            <!-- 前2段：橙色 + 「xxx」加粗 -->
                            <template v-if="block.type === 'orange'">
                                <template v-for="(part, pIndex) in block.parts">
                                    <span
                                        :key="pIndex"
                                        :class="{ 'part-highlight': part.highlight }"
                                    >{{ part.text }}</span>
                                </template>
                            </template>
                            <!-- 规则列表：黑色 -->
                            <template v-else>
                                <div
                                    v-for="(line, lIndex) in block.lines"
                                    :key="lIndex"
                                    class="rule-line"
                                >{{ line }}</div>
                            </template>
                        </div>
                   </div>
                </div>
               <div style="display: flex;">
                 <div class="tip_popup11 cursor_1" style="margin-right: 10px;" @click="closePopup">我对该功能不感兴趣</div>
                   <div class="tip_popup8 cursor_1" @click="handleClick">我已知晓,去使用</div>
                 
               </div>
                  <div class="t-p-t-10">
                    <el-checkbox v-model="checked"></el-checkbox>&nbsp;不再显示
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import data from '@/assets/data';
import api from '@/api/api';
export default {
    props:{
        title:{
            type:String,
            default:'大纲格式标准'
        },
        mode:{
            type:String,
            default:'章节'
        },
        name:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            tips: this.mode === '集'? data.outlineTip1 : this.mode === '章节' ? data.outlineTip : data.seriesTip,
            isVisible: false,
            checked: false,
            reduceOptions:"",
        };
    },
    computed: {
        blocks() {
            if (!this.reduceOptions) return [];
            var lines = this.reduceOptions.split('\n');
            var blocks = [];
            var currentRuleLines = [];

            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];
                if (!line.trim()) continue;

                // #xxx# 单独一行 = 橙色段落
                var match = line.match(/^#(.+)#$/);
                if (match) {
                    if (currentRuleLines.length > 0) {
                        blocks.push({
                            type: 'rule',
                            lines: currentRuleLines.slice()
                        });
                        currentRuleLines = [];
                    }
                    blocks.push({
                        type: 'orange',
                        parts: this.parseOrangeLine(match[1])
                    });
                } else {
                    currentRuleLines.push(line.trim());
                }
            }
            if (currentRuleLines.length > 0) {
                blocks.push({
                    type: 'rule',
                    lines: currentRuleLines
                });
            }
            return blocks;
        }
    },
    methods: {
         handleClick(){
            this.$router.push({ path: '/aiDropMark'})
        },
        openPopup() {
            this.isVisible = true;
            this.getReducelist();
        },
        getReducelist(){
            api.getReduceNotice().then((res)=>{
                if(res.code === 200){
                    this.reduceOptions = res.data
                }
            })
        },
        closePopup() {
            if (this.checked) {
                localStorage.setItem('jc_tip', true)
            }
            this.isVisible = false;
        },
        // 解析橙色行：「xxx」加粗
        parseOrangeLine(text) {
            var parts = [];
            var regex = /「([^」]+)」/g;
            var lastIndex = 0;
            var match;

            while ((match = regex.exec(text)) !== null) {
                if (match.index > lastIndex) {
                    parts.push({
                        text: text.substring(lastIndex, match.index),
                        highlight: false
                    });
                }
                parts.push({
                    text: '「' + match[1] + '」',
                    highlight: true
                });
                lastIndex = regex.lastIndex;
            }
            if (lastIndex < text.length) {
                parts.push({
                    text: text.substring(lastIndex),
                    highlight: false
                });
            }
            return parts;
        }
    }
};
</script>

<style>
#tip_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.tip_popup {
    background: url('../assets/image/icon_tip1.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 15px 40px;
}

.tip_popup1 {
    font-weight: bold;
    font-size: 17px;
    color: #000000;
}

.tip_popup2 {
    width: 400px;
    margin-top: 30px;
}

.tip_popup3 {
    font-size: 15px;
    color: #199BFF;
    margin-bottom: 15px;
}

.tip_popup4 {
    margin-bottom: 15px;
}

.tip_popup5 {
    font-weight: bold;
    font-size: 17px;
    color: #333333;
}

.tip_popup6 {
    font-size: 16px;
    color: #444444;
    margin-top: 5px;
}

.tip_popup7 {
    font-size: 14px;
    color: #362615;
    display: flex;
    align-items: center;
    margin-top: 15px;
}

.tip_popup7 img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
}

.tip_popup8 {
    width: 183px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 42px;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 15px;
    cursor: pointer;
    background: linear-gradient(to right,#0089ff,#005bac);
}
.tip_popup11 {
    width: 183px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 42px;
    font-size: 16px;
    color: #000;
    margin-top: 15px;
    margin-right: 10px;
    cursor: pointer;
    border: #0089ff solid 2px;
    /* background: linear-gradient(to right,#FE8E35,#F72C28 ); */
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* ====== 新增：内容区样式 ====== */
.cursor_1 { cursor: pointer; }
.t-p-t-10 { margin-top: 10px; }

.reduce-block.orange {
    color: #FF6A00;
    font-size: 14px;
    line-height: 1.9;
    font-weight: 500;
    margin-bottom: 10px;
}
.part-highlight {
    font-weight: bold;
    color: #E85500;
}
.reduce-block.rule {
    padding-left: 4px;
}
.rule-line {
    color: #222222;
    font-size: 14px;
    line-height: 2;
    white-space: pre-wrap;
    font-weight: 500;
}
</style>